<div class="container">
  @if ((selectedOption$ | async) === null) {
    <div class="flex">
      <div class="flex header">
        <div>{{ 'rate-week.friday' | transloco }}</div>
        <div class="title">{{ 'rate-week.title' | transloco }}</div>
      </div>
      <div class="flex list">
        @for (item of items; track item) {
          <div class="flex item" (click)="sendFeedback(item)">
            @if (!item.loading) {
              <img [src]="item.src" [alt]="'common.alt-image' | transloco" />
              <div>{{ item.description | transloco }}</div>
            } @else {
              <div class="spinner">
                <c-spinner [loading]="true"></c-spinner>
              </div>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="success-container">
      @if (selectedOption$ | async; as selectedOption) {
        <div class="img-container">
          <img [src]="selectedOption.src" [alt]="'common.alt-image' | transloco" />
          <div class="shadow" [ngClass]="selectedOption.color"></div>
          <div>{{ selectedOption.description | transloco }}</div>
        </div>
      }
      <div class="text-container">
        <img src="assets/img/feedback/rate-week/check.png" [alt]="'common.alt-image' | transloco" />
        <div>{{ 'rate-week.success' | transloco }}</div>
      </div>
      <div class="button-container">
        <c-button (action)="close()" data-test-id="rate-week-component.close.button">{{ 'common.close' | transloco }}</c-button>
      </div>
    </div>
  }
</div>


